export const promotionModel = ({ name, creative, position } = {}) => ({
  name,
  creative,
  position,
})
